import { pipe } from 'ramda';
import { setAction, setLabel } from '@creditas-lab/analytics-events';
import { DispatchEvent, dispatchFrontendDashboardEvent } from './commons';

const dispatchHeaderEvent: DispatchEvent = pipe(
  setAction('header_menu'),
  dispatchFrontendDashboardEvent,
);

const dispatchSimulateLoanEvent: DispatchEvent = pipe(setLabel('simulator'), dispatchHeaderEvent);

const dispatchSimulateAtWorkLoanEvent: DispatchEvent = pipe(
  setLabel('simulator_atwork'),
  dispatchHeaderEvent,
);

const dispatchAtWorkEvent: DispatchEvent = pipe(setLabel('atwork'), dispatchHeaderEvent);

const dispatchSupportEvent: DispatchEvent = pipe(setLabel('help'), dispatchHeaderEvent);

const dispatchLogoutEvent: DispatchEvent = pipe(setLabel('logout'), dispatchHeaderEvent);

const dispatchAppleStoreEvent: DispatchEvent = pipe(setLabel('apple_store'), dispatchHeaderEvent);

const dispatchGoogleStoreEvent: DispatchEvent = pipe(setLabel('google_store'), dispatchHeaderEvent);

export {
  dispatchSimulateLoanEvent,
  dispatchSimulateAtWorkLoanEvent,
  dispatchAtWorkEvent,
  dispatchSupportEvent,
  dispatchLogoutEvent,
  dispatchAppleStoreEvent,
  dispatchGoogleStoreEvent,
};
